import { Coffees, User } from "@types";

const findUserCoffee = (coffees: Coffees, user: User | null) => {
  return coffees.matchs.find((match) =>
    match.participants.some((participant) => participant.email === user?.email)
  );
};

export { findUserCoffee };
